import {URL_TYPE} from '../actions/types';
import {network} from 'src/constants/config';

const INITIAL_STATE = {
  BaseUrlApi: network?.baseUrl,
  BaseUrlAuth: '',
};

const Url = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case URL_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default Url;
